import React from 'react';
import classNames from 'classnames';

import * as styles from './styles/styles.module.scss';

const SummaryMetrics = (): JSX.Element => {
  const hello = 'metrics';

  return (
    <div className={styles.summaryMetrics}>
      <div className={classNames(styles.summaryMetric, styles.widget)}>
        <h3 className={styles.summaryMetricTitle}>Total trails</h3>
        <h3 className={styles.summaryMetricValue}>35</h3>
      </div>
      <div className={classNames(styles.summaryMetric, styles.widget)}>
        <h3 className={styles.summaryMetricTitle}>Total page views</h3>
        <h3 className={styles.summaryMetricValue}>10.5k</h3>
        <span className={classNames(styles.summaryMetricValueChange, styles.negative)}>-1.7%</span>
      </div>
      <div className={classNames(styles.summaryMetric, styles.widget)}>
        <h3 className={styles.summaryMetricTitle}>Total reviews</h3>
        <h3 className={styles.summaryMetricValue}>2.2k</h3>
        <span className={classNames(styles.summaryMetricValueChange, styles.positive)}>+7.4%</span>
      </div>
      <div className={classNames(styles.summaryMetric, styles.widget)}>
        <h3 className={styles.summaryMetricTitle}>Average trail rating</h3>
        <h3 className={styles.summaryMetricValue}>4.4</h3>
        <span className={classNames(styles.summaryMetricValueChange, styles.positive)}>+2.3%</span>
      </div>
    </div>
  );
};

export default SummaryMetrics;
